export default "__VITE_ASSET__CPK6aHfG__"